import script from "./goRinSyo0005.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0005.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0005.vue?vue&type=style&index=0&id=0938729e&lang=scss"

const __exports__ = script;

export default __exports__